import entities from 'entities';
import { Parser } from 'html-to-react';
import xss from 'xss';

// remove scripts and styles, allow links and images
const gentleFilter = new xss.FilterXSS({
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script', 'style'],
    whiteList: {
        a: ['alt', 'href', 'target'],
        b: [],
        br: [],
        font: ['size'],
        i: [],
        img: ['width', 'height', 'src', 'srcset', 'title'],
        li: [],
        ol: [],
        p: [],
        strong: [],
        table: [],
        td: [],
        tr: [],
        ul: [],
    },
});

// remove scripts, styles and images, allow links
const gentleOldFilter = new xss.FilterXSS({
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script', 'style', 'img'],
    whiteList: {
        a: ['alt', 'target'],
        b: [],
        br: [],
        font: [],
        i: [],
        li: [],
        ol: [],
        p: [],
        strong: [],
        table: [],
        td: [],
        tr: [],
        ul: [],
    },
});

// Create a filter for removing all the html in the case that we fail parsing
const bruteFilter = new xss.FilterXSS({
    stripIgnoreTag: true, // filter out all HTML not in the whilelist
    stripIgnoreTagBody: ['script', 'style'], // the script tag is a special case, we need to filter out its content
    whiteList: [], // empty, means filter out all tags
});

const htmlToReactParser = new Parser();

// sanitize xss and return react elements
export const safelyRender = (html, wrapper = 'div', old) => {
    const filter = old ? gentleOldFilter : gentleFilter;
    // first we will pull out all the non breaking spaces then we decode and process
    let safeHtml = filter.process(entities.decodeHTML((html || '').replace(/\u00A0/g, ' '))).trim();
    try {
        safeHtml = htmlToReactParser.parse(`<${wrapper}>${safeHtml}</${wrapper}>`);
    } catch (e) {
        safeHtml = bruteFilter.process(html).trim();
    }
    return safeHtml;
};

export const safelyRenderMessages = html => {
    let safeHtml = entities.decodeHTML(html).trim();
    try {
        safeHtml = htmlToReactParser.parse(`${safeHtml}`);
    } catch (e) {
        safeHtml = bruteFilter.process(html).trim();
    }
    return safeHtml;
};

// use default xss filters and decode html symbols into a text string
export const sanitizeHtml = text => entities.decodeHTML(xss(text));

const cleanSpace = text => text.replace(/\s/g, ' ');

// remove all html and return a text string
export const removeHtml = text => {
    let safeHtml = bruteFilter.process(text).trim();
    safeHtml = cleanSpace(safeHtml);
    return safeHtml;
};

export const sanitizeHeaderText = text => {
    return entities.decodeHTML(removeHtml(text)).replace(/\s\s+/g, ' ');
};
